// extracted by mini-css-extract-plugin
export default {"line":"Resume_line__vwoNj","point":"Resume_point__E0cEj"};